import React from "react";
import { useSelector } from "react-redux";
import AutorizadosPill from "./AutorizadosPill";
import AgregarAutorizado from "./AgregarAutorizado";
export default function Autorizados() {
  const figuritas = useSelector((state) => state.figuritasReducer.figuritas);

  return (
    <div className="autorizadosMainContainer">
      {figuritas.autorizados.some((autorizado) => autorizado.editar) && (
        <>
          <p className="autorizadosTitle">Usuarios autorizados a editar</p>
          <div className="containerAutorizados">
            {figuritas.autorizados
              .filter((autorizado) => autorizado.editar)
              .map((autorizado) => {
                return (
                  <AutorizadosPill
                    key={autorizado.email}
                    autorizado={autorizado}
                  />
                );
              })}
          </div>
        </>
      )}
      {figuritas.autorizados.some((autorizado) => !autorizado.editar) && (
        <>
          <p className="autorizadosTitle">Usuarios autorizados a visualizar</p>
          <div className="containerAutorizados">
            {figuritas.autorizados
              .filter((autorizado) => !autorizado.editar)
              .map((autorizado) => {
                return (
                  <AutorizadosPill
                    key={autorizado.email}
                    autorizado={autorizado}
                  />
                );
              })}
          </div>
        </>
      )}
      <p className="autorizadosTitle">Agregar usuario autorizado</p>

      <div>
        <AgregarAutorizado />
      </div>
    </div>
  );
}
